import React from 'react';
import './Video.css';

import { useAppSelector } from 'hooks/redux';
import { pathVideo } from 'config';

import { MoreArrow } from 'components';
import { videosSelector } from 'store/ducks/homepage/selectors/videosSelector';
// import { personsSelector } from 'store/ducks/homepage/selectors/personsSelector';

export function Video() {
  const videos = useAppSelector(videosSelector);

  return (
    <section className="video">
      <h2 className="page-title video__title">Видео</h2>
      <MoreArrow type="video" link={pathVideo}>
        Все видео
      </MoreArrow>
      {videos &&
        videos.length > 0 &&
        [videos[0], videos[1], videos[2]].map(item => {
          if (!item) return null;

          const { id, link, img, title, date, exclusive_material } = item;
          return (
            <article className="card card--m" key={id}>
              <a className="materials__link" href={link}>
                <img src={img} alt={title} className="materials__img" />
                <div className="materials__common">
                  <h3
                    className="materials__title"
                    dangerouslySetInnerHTML={{ __html: title }}
                  ></h3>
                  <div className="materials__date">{date}</div>
                </div>
              </a>
              {exclusive_material && (
                <div className="tag exclusive">Эксклюзив</div>
              )}
            </article>
          );
        })}
    </section>
  );
}
